<template>

</template>

<script>
    export default {
        name: "AboutUs"
    };
</script>

<style scoped>

</style>
